import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    permissions: null,
    admin: false,
    standard: false,
    rowsPerPage: 10
  },
  mutations: {
    permissions(state, permissions) {
      state.permissions = permissions
    },
    admin(state, admin) {
      state.admin = admin
    },
    standard(state, standard) {
      state.standard = standard
    },
    rowsPerPage(state, rowsPerPage) {
      state.rowsPerPage = rowsPerPage
    },
  },
  getters: {
    permissions: state => state.permissions
  }
});



// WEBPACK FOOTER //
// ./src/store.js